import React, { Component } from "react"
import ReactPlayer from "react-player"
import { connect } from "react-redux"
import { BiVolume } from "react-icons/bi"
import { isMobile } from "react-device-detect"

import Socket from "../../lib/socket"

// Styles
import "./styles/segmentWindow.css"
import "../../../src/styles/styles.css"

class SegmentWindow extends Component {
  constructor() {
    super()

    this.state = {
      playing: true,
      muted: false,
    }

    if (Socket.isSocket()) {
      Socket.getSocket().addEventListener("message", (event) => {
        const payload = JSON.parse(event.data) || {}

        if (payload.event === "play_jingle") {
          this.videoPlayer.seekTo(0)
        }
      })
    }
  }

  mute = () => {
    this.setState({ playing: false })
    this.setState({
      muted: true,
      playing: true,
    })
  }

  unmute = () => {
    if (this.state.muted === true) {
      this.setState({ muted: false })
    }
  }

  renderVideo(video) {
    return (
      <div>
        <button
          onClick={this.unmute}
          className={[
            "btn-mute",
            this.state.muted ? "sound-mute" : "sound-hide",
          ].join(" ")}
        >
          <div className="sound" title="Turn On/Off Sound">
            <BiVolume />
            <div className="sound--wave sound--wave_one" />
            <div className="sound--wave sound--wave_two" />
            <div className="sound--wave sound--wave_three" />
          </div>
        </button>
        <ReactPlayer
          url={video}
          ref={(ref) => {
            this.videoPlayer = ref
          }}
          playing={this.state.playing}
          muted={this.state.muted}
          width="100%"
          height="100%"
          onError={this.mute}
          volume={isMobile ? 0 : 1}
        />
      </div>
    )
  }

  renderFullImage(image) {
    return (
      <img
        alt=""
        className="imgContainer"
        src={image}
        style={{
          height: `${window.innerHeight}px`,
        }}
      />
    )
  }

  render() {
    return (
      <div className="segmentWindow">
        {this.props.video
          ? this.renderVideo(this.props.video)
          : this.renderFullImage(this.props.banner_live)}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { video, banner_live, segment_id } = state.ui.currentSegment

  return {
    video,
    banner_live,
    segment_id,
  }
}

export default connect(mapStateToProps)(SegmentWindow)



// WEBPACK FOOTER //
// ./src/components/segmentWindow/view.js